var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading flex-column"},[_c('div',{staticClass:"loading-box"}),(_vm.loadingText != '')?_c('span',[_vm._v(_vm._s(_vm.loadingText))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }